import { apiClient } from './apiClient'

function checkTokenValidity(token: string) {
    return apiClient().get('/token/' + token)
}

export default {
    checkTokenValidity
}
